import { Description, Field, Input, Label } from '@headlessui/react'
import { type InputProps } from '@headlessui/react/dist/components/input/input.d'
import { _t } from "core/language";
import React from "react";

type TCInputControl = {
  label?: string,
  value?: string,
  type?: 'text' | 'password',
  format?: RegExp, // regex
  readonly?: boolean,
  className?: string,
  description?: string,
  error?: string,
  onChange?: (value: string) => void,
  maxLength?: number,
  icon?: any,
  status?: 'success' | 'fail' | "",
  classNameInput?: string,
  classNameIcon?: string,
  onEnter?: () => void,
} & Omit<InputProps, 'onChange'>

export default function CInputControl({
  label,
  value = '',
  onChange,
  type = 'text',
  format,
  className,
  description,
  error,
  maxLength,
  icon,
  status,
  classNameInput,
  classNameIcon,
  onEnter,
  ...props
}: TCInputControl) {

  const _onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    if (value && format && !format.test(value)) {
      return
    }

    if (maxLength && value.length > maxLength) {
      return
    }

    onChange?.(value)
  }

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onEnter?.();
    }
  }

  return (
    <div className={`w-full ${className} ${label ? 'min-h-[88px]' : ''}`}>
      <Field>
        {label && <Label className="text-dark text-[13px] mb-[7px] block font-medium">
          {label}
        </Label>}
        <div className="relative">
          {icon && <div className="absolute inset-y-0 left-0 flex items-center pl-3">
            <img src={icon} className={`w-5 h-5 ${classNameIcon}`} alt='img' />
          </div>}

          <Input
            {...props}
            type={type}
            className={`
              w-full rounded px-[13px] py-[9px] leading-5 text-[13px] focus:outline-none
              border
              ${icon ? 'pl-[45px]' : ''}
              ${status ? 'pr-10' : ''}
              ${error ? '' : 'border-gray-300 focus:border-gray-400'}
              ${classNameInput}
            `}
            value={value}
            onChange={_onChange}
            onKeyDown={onKeyDown}
          />

          {status && <div className="absolute inset-y-0 right-0 flex items-center pr-3">
            {status === 'success' && <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>}
            {status === 'fail' && <svg className="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>}
          </div>}
        </div>
        
        {description && <Description className="text-[11px] mt-[6px]">{_t(description)}</Description>}
        {error && <Description className="text-[11px] mt-[6px] text-error">{_t(error)}</Description>}
      </Field>
    </div>
  )
}
